
import axios from 'axios';
import _ from 'lodash';
import React, { Component}  from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import { ResponsiveTable } from 'ui/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CircularProgress from '@material-ui/core/CircularProgress';
import { DateTimeDisplay } from 'core/Display';
import Colors from 'ui/Colors';


export default class ScheduleDetailTable extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      items: [],
      filter: {}
    }
  }

  onDetail = (item) => {
    this.props.history.push(`/schedule/${item.id}`);
  };

  loadItems = (item) => {
    const stateFilter = this.state.filter;
    const filter = {};

    if (item.driver) {
        filter['driver'] = item.driver.id;
    }
    else {
      filter['driver__isnull'] = true;
    }

    if (item.semi_trailer) {
        filter['semi_trailer'] = item.semi_trailer.id;
    }
    else {
      filter['semi_trailer__isnull'] = true;
    }

    if (item.tractor_unit) {
        filter['tractor_unit'] = item.tractor_unit.id;
    }
    else {
      filter['tractor_unit__isnull'] = true;
    }

    if (!_.isEqual(stateFilter, filter)) {
      this.setState({
        loading: true,
        filter: filter
      });
      axios.get('schedule', {params: filter}).then(res => {
        this.setState({
          loading: false,
          items: res.data.results
        })
      })
    }
  };

  componentDidMount() {
    const { item } = this.props;
    this.loadItems(item);
  }

  // eslint-disable-next-line
  componentWillReceiveProps(nextProps, nextContext) {
    const { item } = nextProps;
    this.loadItems(item);
  }

  render() {
    const { item } = this.props;
    const { items, loading } = this.state;
    const itemId = item.id;

    if (!item.driver && !item.semi_trailer && !item.tractor_unit) {
      return <React.Fragment />
    }

    return (
      <TableContainer component={Paper} className={'mt-20'}>
        <ResponsiveTable>
           <TableHead>
            <TableRow>
              <TableCell component="th" scope="row">Дата начала</TableCell>
              <TableCell component="th" scope="row">Дата окончания</TableCell>
              <TableCell component="th" scope="row">Комментарий</TableCell>
              <TableCell component="th" scope="row">Статус</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan={7}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            )}
            {items.map(item => {
              return (
                <TableRow
                  key={item.id}
                  hover={true}
                  onClick={() => this.onDetail(item)}
                  style={{backgroundColor: item.id === itemId ? Colors.Gray2 : ''}}
                  className={'pointer'}
                >
                  <TableCell><DateTimeDisplay value={item.date_start} /></TableCell>
                  <TableCell><DateTimeDisplay value={item.date_end} /></TableCell>
                  <TableCell>{item.comment}</TableCell>
                  <TableCell>{item.status_display}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </ResponsiveTable>
      </TableContainer>
    )
  }
}
